var arrobj = [];       
  var datamap= {};

  function getParameterByName(name, url = window.location.href) {
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  function getQueryParam(param) {
    const queryString = window.location.search; // Get the query string part of the URL
    const urlParams = new URLSearchParams(queryString); // Create URLSearchParams object
    return urlParams.get(param); // Retrieve the value of the specified parameter
  }

  function updateUrlWithDistance() {
    const currentUrl = window.location.href; // Get the current URL
    const selectedDistance = $('#distances').val(); // Get the selected distance

    // Check if the URL already contains the 'distances' parameter
    const url = new URL(currentUrl);
    url.searchParams.set('distances', selectedDistance); // Add or update the 'distances' parameter

    // Redirect to the updated URL
    window.location.href = url.toString();
  }

  
  var handler_url = getQueryParam('location');  
  var distance = getParameterByName('distances');

  if(handler_url==null){
      handler_url ='nottingham';
  }
   if(distance==null){
      distance ='all';
  }
  console.log("Handle "+handler_url)
  $("#distances").val(distance)
 
  $("#location").val(handler_url)
  $('#distances').on('change', updateUrlWithDistance);
  var cbinfo = cstMetaFields[handler_url];  
  $("#map").html('<div class="map_loading_container"><div id="preloader"><div class="loader"></div></div></div>');
  $("#loading").show(); 
  let loadlat = ''
  let loadlong = ''

    var geocoder =  new google.maps.Geocoder();
    geocoder.geocode( { 'address': handler_url}, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          
          loadlat = results[0].geometry.location.lat();
          loadlong = results[0].geometry.location.lng();
          setTimeout(initMap,2000)          
          return 
        } else {
          alert("Something got wrong " + status);
        }
      });

  function initMap() {      
    $("#locationSet").show();
    var markers = [];
    var image = {
       // url: 'https://cdn.shopify.com/s/files/1/0560/9363/8840/files/book.png?v=1726220955',
      
      scaledSize: new google.maps.Size(15, 20)
    };
    var cbinfo = cstMetaFields[handler_url];
    
   
    var dlng = loadlong;
    var dlat = loadlat;     
    // Create a map.
    var map = new google.maps.Map(document.getElementById('map'), {      
      // Set up options and styles for map.
      center: {
        lat: dlat,
        lng: dlng
      },
      zoom: 14,
      mapTypeControl: false,
      streetViewControl: false ,
      scrollwheel: false,
      scaleControl: false,
      draggable: true,
      mapTypeControl: false,
      disableDefaultUI: true

    });

    setTimeout(function(){
      map.setZoom(6); 
  },1);
    

    
    for (var prop in cstMetaFields) {     
      if(cstMetaFields[prop].product_longtitude!="" && cstMetaFields[prop].product_latitude!=""){
        var product_distance = 200;
        var calDistance ='all';
        if(distance!=null && distance!=''){
          calDistance = distance;
          product_distance =distance;
        }

        var milesCal = getDistance(dlng, dlat,cstMetaFields[prop].product_longtitude, cstMetaFields[prop].product_latitude);
        if(calDistance !="all"){ 
            if(milesCal <= calDistance ){
              addMarker(cstMetaFields[prop])
              // addMarker(cstMetaFields[prop],image)
            }
        }else{
          addMarker(cstMetaFields[prop])
          // addMarker(cstMetaFields[prop],image)
        } 
        
      }
    }

    // Create marker(s).

   var currentInfoWindow = null; // To track the currently open infowindow

    function addMarker(properties, image) {   
        var datamap = {};
        var title = properties.product_title;
        var content = properties.product_excerpt;
        var icon = image;
        var position = new google.maps.LatLng(properties.product_latitude, properties.product_longtitude);     
    
        var marker = new google.maps.Marker({
            map: map,
            icon: icon,
            position: position        
        });
    
        markers.push(marker);
        if (properties.icon) {
            // Set up icon image.
            marker.setIcon(properties.icon);
        }
    
        datamap.coordinates = [cstMetaFields[prop].product_longtitude, cstMetaFields[prop].product_latitude];
        datamap.title = cstMetaFields[prop].product_top_title;
        datamap.description = cstMetaFields[prop].product_excerpt;
        datamap.image = cstMetaFields[prop].product_image;
        datamap.price = '£' + parseFloat(cstMetaFields[prop].product_price) / 100;
        datamap.url = cstMetaFields[prop].product_url;
        datamap.title = cstMetaFields[prop].product_title;
        datamap.buy = cstMetaFields[prop].product_variant;    
        datamap.city = cstMetaFields[prop].product_city_name;   
        datamap.product_trip_advisor = cstMetaFields[prop].product_trip_advisor;
    
        var contentString = productHtmlset(datamap);
    
        var infowindow = new google.maps.InfoWindow({
            content: contentString,
            maxWidth: 400
        });
    
        marker.addListener('click', function () {
            if (currentInfoWindow) {
                currentInfoWindow.close();
            }
            infowindow.open(map, marker);
            currentInfoWindow = infowindow;
            map.panTo(this.getPosition());
            closeAllInfoWindows(map, marker);

          // Attach click event to close the infowindow when the "Close" button is clicked
            google.maps.event.addListenerOnce(infowindow, 'domready', function() {
                document.querySelector('.infowindow-close-btn').addEventListener('click', function() {
                    infowindow.close();
                });
            });
        });
    }
    
    function closeAllInfoWindows(map, currentMarker) {
        markers.forEach(function(marker) {
            if (marker !== currentMarker && marker.infowindow) {
                marker.infowindow.close(map, marker);
            }
        });
    }
  
  }

   function productHtmlset(data){    
     // console.log(data);
     var product_content='';    
     product_content+='<div class="new_product_item">';
      product_content+='<div class="new-price-card">';          
        product_content+='<div class="new-left-product new-design">';
          product_content+='<div class="new-product_image_wrraper">';
            product_content+='<a href="'+data.url+'"><img class="ls-is-cached lazyloaded" src="'+data.image+'"></a>';      
            product_content+='<dl class="price price--listing align-center">';
              product_content+='<div class="price__regular m-0">';
                product_content+='<dt><span class="visually-hidden visually-hidden--inline">Regular price</span></dt>';
                product_content+='<dd class="m-0"><span class="price-item price-item--regular">'+ data.price+'</span></dd>';
            product_content+='</dl>';
          product_content+='</div>';
          product_content+='<div class="new-product_info">';
            product_content+='<a class="new-city_names" href="'+data.url+'">'+data.city+'</a>';
            product_content+='<a href="'+data.url+'" class="new-product_info-title">';
              product_content+='<h1>'+data.title+'</h1>';
              if(data.product_trip_advisor == "true"){
                product_content+='<img data-src="https://cdn.shopify.com/s/files/1/0560/9363/8840/files/tripadvisor_own.webp?v=1666181994" class="logo_green_mobile show-mobile lazyloaded" loading="lazy" src="https://cdn.shopify.com/s/files/1/0560/9363/8840/files/tripadvisor_own.webp?v=1666181994">';
              }
            product_content+='</a>';
            product_content+='<p class="sow-mobile">'+data.description+'</p>';
            product_content += '<div class="infowindow-close">';
              product_content += '<a href="javascript:void(0);" class="infowindow-close-btn"><span style="mask-image: url(&quot;data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M19%206.41L17.59%205%2012%2010.59%206.41%205%205%206.41%2010.59%2012%205%2017.59%206.41%2019%2012%2013.41%2017.59%2019%2019%2017.59%2013.41%2012z%22/%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%3C/svg%3E&quot;);"></span>Close</a>';
            product_content += '</div>';
          product_content += '</div>';
        product_content += '</div>'; 
        product_content+='<div class="product-buttons custom-coll-page">';
          // product_content+='<p class="priceing"></p>';
          product_content+='<a href="'+data.url+'" class="view" data-id="'+data.buy+'">View Details</a>';
          product_content+='<button type="button" class="addtocartlist add_to_cart_ajax_cust_info add_to_cart_content" data-gift="0" data-id="'+data.buy+'">Add to cart</button>';
        product_content+='</div>';    
      product_content+='</div>';
    product_content+='</div>';
    return product_content;
  }
  function getDistance(lat1, lon1, lat2, lon2, unit) {
      if ((lat1 == lat2) && (lon1 == lon2)) {
          return 0;
      }
      else {
          var radlat1 = Math.PI * lat1/180;
          var radlat2 = Math.PI * lat2/180;
          var theta = lon1-lon2;
          var radtheta = Math.PI * theta/180;
          var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
          if (dist > 1) {
              dist = 1;
          }
          dist = Math.acos(dist);
          dist = dist * 180/Math.PI;
          dist = dist * 60 * 1.1515;
          if (unit=="K") { dist = dist * 1.609344 }
          if (unit=="N") { dist = dist * 0.8684 }
          return Math.round(dist);
      }
  }